var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isThreeBounceNoMargin
      ? _c(
          "div",
          {
            staticClass: "sk-three-bounce",
            staticStyle: { margin: "0px auto" }
          },
          [
            _c("div", { staticClass: "sk-child sk-bounce1" }),
            _vm._v(" "),
            _c("div", { staticClass: "sk-child sk-bounce2" }),
            _vm._v(" "),
            _c("div", { staticClass: "sk-child sk-bounce3" })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isThreeBounce
      ? _c("div", { staticClass: "sk-three-bounce" }, [
          _c("div", { staticClass: "sk-child sk-bounce1" }),
          _vm._v(" "),
          _c("div", { staticClass: "sk-child sk-bounce2" }),
          _vm._v(" "),
          _c("div", { staticClass: "sk-child sk-bounce3" })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isFoldingCube
      ? _c("div", { staticClass: "sk-folding-cube" }, [
          _c("div", { staticClass: "sk-cube1 sk-cube" }),
          _vm._v(" "),
          _c("div", { staticClass: "sk-cube2 sk-cube" }),
          _vm._v(" "),
          _c("div", { staticClass: "sk-cube4 sk-cube" }),
          _vm._v(" "),
          _c("div", { staticClass: "sk-cube3 sk-cube" })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }